<template>
  <div style="height: 100%;position: relative;">
    <!--    <div class="canvas"></div>-->
    <!--    <img class="background" :src="this.backgroundIMG"/>-->
    <img class="background" src="../../../static/img/background.png"/>
    <company-intro></company-intro>
    <detail-intro></detail-intro>
    <bottom-info style="position:absolute;top:1860px"></bottom-info>
  </div>
</template>

<script>
    import axios from 'axios'
    import companyIntro from './Components/companyIntro'
    import detailIntro from './Components/detailIntro'
    import bottomInfo from '../../Common/bottomInfo'

    export default {
        data() {
            return {
                backgroundIMG: ''
            }
        },
        components: {
            companyIntro,
            detailIntro,
            bottomInfo
        },
        methods: {
            getbackground() {
                axios.get('/static/mock/aboutUs.json')
                    .then(this.getSucc);
            },

            getSucc(res) {
                res = res.data;
                // const data = res.data;
                this.backgroundIMG = res.backgroundIMG;
            },
        },
        mounted() {
            this.getbackground();
        },
    }
</script>

<style scoped>
  .background {
    /*height: 20%;*/
    width: 100%;
    min-width: 1366px;
    background-size: cover;
    position: absolute;
    top: 0;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Intro/aboutUs.vue